module.exports = __webpack_public_path__ + "static/media/728x300.2b9eb59b.png";